export default "__VITE_ASSET__C6_v4U3c__"